module.exports = __webpack_public_path__ + "static/img/M-1.a0ca4bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mzhongfu/M-1.png
// module id = mYbA
// module chunks = 0